export const SET_SECTION_STATUS = 'contributions/SET_SECTION_STATUS';
export const SET_CONTRIBUTIONS = 'contributions/SET_CONTRIBUTIONS';
export const UPDATE_NOTE = 'contributions/UPDATE_NOTE';
export const APPEND_CONTRIBUTIONS = 'results/APPEND_CONTRIBUTIONS';
